





























































































































































































































































































































































































import { CvValue, UpsertProduct, Product, ProductMetadata, SearchTeamMemberOptions, TeamMember, EditorialProject } from '@/models'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { CV_VALUE_TYPE_PROD, CV_VALUE_COUNTRY, CV_VALUE_SUBJECT, CV_VALUE_EDUCATION, CV_VALUE_LANGUAGE, CV_VALUE_COURSE_LEVEL, CV_VALUE_REGION, CV_VALUE_PRODUCT_WORK_TYPE, CV_VALUE_PRODUCT_COLLECTION, CV_VALUE_PRODUCT_SERIES } from '@/utils/constants'
import { CvValueUtils } from '@/utils/cv-value-utils'
import { ActionTypes } from '@/store/action-types'
import { Utils } from '@/utils'
import {
  PRODUCT_FIXED_OPTIONAL_FIELDS,
  PRODUCT_FIXED_REQUIRED_FIELDS,
  PRODUCT_TYPE_FIELDS,
  ProductFieldDefinition,
  ProductFieldRules,
  loadMaterialTypes,
  productFieldI18nKey
} from '@/utils/product-fields'

const emptyProductMetadata = (): ProductMetadata => ({
  subject: '',
  subjectLabel: '',
  region: '',
  regionLabel: '',
  educationLevel1: '',
  educationLevel2: '',
  developmentManager: '',
  developmentProject: '',
  layoutManager: '',
  language: '',
  wwIssueId: '',
  wwIssue: '',
  wwBrandId: '',
  wwBrand: '',
  assetsActive: false,
  sendBtovenFromStructureLdx: false,
  btovenCodeCourse: '',
  btovenCodeSubject: '',
  campaign: '',
  productionCampaign: '',
  organizationalLevel1: '',
  organizationalLevel2: '',
  parentFolderEcUrl: '',
  collection: '',
  series: '',
  author: '',
  illustrator: '',
  readingAge: '',
  publicationDate: ''
})

// Stored metadata keeps the CV short code: 'edct-pri' is saved as 'pri'
const toShortCode = (value: string | undefined, type: string) =>
  value && value.startsWith(type + '-') ? value.substring(type.length + 1) : value

// Fields checked by formOk; the organizational levels follow the production project instead
const FORM_FIELDS = [
  ...PRODUCT_FIXED_REQUIRED_FIELDS, ...PRODUCT_FIXED_OPTIONAL_FIELDS, ...PRODUCT_TYPE_FIELDS.map(item => item.field)
]
const PRODUCT_FIELDS = [
  'code', 'name', 'type', 'editorialProject', 'country',
  ...PRODUCT_TYPE_FIELDS.filter(item => item.onProduct).map(item => item.field)
]

// Fields of the form below the general ones: a block without title for the fields no material
// type lists, then one titled block per material type of the project
interface FieldBlock {
  key: string;
  title: string;
  fields: ProductFieldDefinition[];
}

@Component
export default class UpsertProductModal extends Vue {
  @Prop({ required: false }) productUpdate: Product

  private utils = Utils
  public productFieldI18nKey = productFieldI18nKey

  private product: UpsertProduct = {
    id: '0',
    name: '',
    code: '',
    type: '',
    editorialProject: '',
    country: '',
    metadata: {},
    statusType: '',
    workType: '',
    isModel: false
  }

  private productMetadata: ProductMetadata = emptyProductMetadata()
  private loadingModelCode = false

  private regionArray: string[] = []
  private organizationalLevel1Array: string[] = []
  private organizationalLevel2Array: string[] = []

  private years: Array<number> = Utils.getYearsForCampaign(2019)
  private countries: CvValue[] = []
  private cvValues: CvValue[] = []
  private cvSubject: CvValue[] = []
  private cvRegion: CvValue[] = []
  private cvEducation: CvValue[] = []
  private cvCourseLevel: CvValue[] = []
  private cvLanguage: CvValue[] = []
  private cvWorkType: CvValue[] = []
  private teamMembers: TeamMember[] = []
  private materialTypes: CvValue[] = []
  private cvCollections: CvValue[] = []
  private cvSeries: CvValue[] = []

  get availableTypes() {
    return this.cvValues
  }

  get editorialProjects() {
    // New products only go to projects the user can create products in
    return this.isUpdate ? this.$store.getters.editorialProjects : this.$store.getters.creatableEditorialProjects
  }

  get editorialProjectSelected() {
    if (this.product.editorialProject !== '') {
      return this.editorialProjects.find((item: EditorialProject) => item.id === this.product.editorialProject)
    }
  }

  get fieldRules(): ProductFieldRules {
    return new ProductFieldRules(this.materialTypes, this.editorialProjectSelected)
  }

  get fieldBlocks(): FieldBlock[] {
    const rules = this.fieldRules
    const visible = (fields: ProductFieldDefinition[]) => fields.filter(item => rules.isVisible(item.field))
    return [
      { key: 'general', title: '', fields: visible(rules.unassignedFields()) },
      ...rules.materialTypeGroups().map(group => ({ key: group.codeId, title: group.name, fields: visible(group.fields) }))
    ].filter(block => block.fields.length > 0)
  }

  public fieldId(definition: ProductFieldDefinition): string {
    return 'productField' + definition.field.charAt(0).toUpperCase() + definition.field.slice(1)
  }

  // Object the field value lives in
  public fieldTarget(definition: ProductFieldDefinition): Record<string, unknown> {
    return (definition.onProduct ? this.product : this.productMetadata) as unknown as Record<string, unknown>
  }

  public cvOptions(definition: ProductFieldDefinition): CvValue[] {
    const options: Record<string, CvValue[]> = {
      [CV_VALUE_SUBJECT]: this.cvSubject,
      [CV_VALUE_EDUCATION]: this.cvEducation,
      [CV_VALUE_COURSE_LEVEL]: this.cvCourseLevel,
      [CV_VALUE_PRODUCT_WORK_TYPE]: this.cvWorkType,
      [CV_VALUE_PRODUCT_COLLECTION]: this.cvCollections,
      [CV_VALUE_PRODUCT_SERIES]: this.cvSeries
    }
    return (definition.cvType && options[definition.cvType]) || []
  }

  public fieldLabel(field: string, labelKey: string): string {
    return this.$t(labelKey) + (this.fieldRules.isRequired(field) ? ' *' : '')
  }

  private fieldValue(field: string): unknown {
    if (field === 'region') return this.regionArray.join(',')
    if (PRODUCT_FIELDS.includes(field)) return (this.product as unknown as Record<string, unknown>)[field]
    return (this.productMetadata as unknown as Record<string, unknown>)[field]
  }

  get countriesSelect() {
    return this.countries
  }

  get organizationalLevel1Select() {
    if (!this.editorialProjectSelected || !this.editorialProjectSelected.organizationalLevel1) {
      return []
    }

    return this.editorialProjectSelected.organizationalLevel1.split(',')
  }

  get organizationalLevel2Select() {
    if (!this.editorialProjectSelected || !this.editorialProjectSelected.organizationalLevel2) {
      return []
    }

    return this.editorialProjectSelected.organizationalLevel2.split(',')
  }

  get regionSelect() {
    return this.cvRegion
  }

  get languageSelect() {
    return this.cvLanguage
  }

  get isUpdate() {
    return this.productUpdate !== null && this.productUpdate.id !== null && this.productUpdate.id !== undefined
  }

  @Watch('productUpdate', { deep: true })
  onProductUpdateChanged() {
    this.resetForm()
  }

  @Watch('editorialProjectSelected', { deep: true })
  onEditorialProjectSelectedChanged() {
    if (this.editorialProjectSelected && !this.editorialProjectSelected.organizationalLevel1) {
      this.productMetadata.organizationalLevel1 = ''
    }
    if (this.editorialProjectSelected && !this.editorialProjectSelected.organizationalLevel2) {
      this.productMetadata.organizationalLevel2 = ''
    }
  }

  private formOk(): boolean {
    const requiredFieldsOk = FORM_FIELDS
      .filter(field => this.fieldRules.isRequired(field))
      .every(field => !!this.fieldValue(field))
    const project = this.editorialProjectSelected
    const levelsOk = !project || (
      (!project.organizationalLevel1 || !!this.productMetadata.organizationalLevel1) &&
      (!project.organizationalLevel2 || !!this.productMetadata.organizationalLevel2)
    )
    return requiredFieldsOk && levelsOk
  }

  hideModal() {
    this.clearForm()
    this.$bvModal.hide('UpsertProductModal')
  }

  created() {
    this.loadEditorialProjects()
    this.loadCountries()
    this.loadCvValues()
    this.loadSubject()
    this.loadRegion()
    this.loadEducation()
    this.loadCourseLevel()
    this.loadLanguage()
    this.loadWorkType()
    this.loadTeamMembers()
    this.loadMaterialTypes()
    this.loadCollectionsAndSeries()
  }

  private async loadEditorialProjects() {
    this.$store.dispatch(ActionTypes.LOAD_EDITORIAL_PROJECTS)
  }

  private async loadCountries() {
    this.countries = await CvValueUtils.getCvValuesByType(CV_VALUE_COUNTRY)
  }

  private async loadCvValues() {
    this.cvValues = await CvValueUtils.getCvValuesByType(CV_VALUE_TYPE_PROD)
  }

  private async loadSubject() {
    this.cvSubject = await CvValueUtils.getCvValuesByType(CV_VALUE_SUBJECT)
  }

  private async loadRegion() {
    this.cvRegion = await CvValueUtils.getCvValuesByType(CV_VALUE_REGION)
  }

  private async loadEducation() {
    this.cvEducation = await CvValueUtils.getCvValuesByType(CV_VALUE_EDUCATION)
  }

  private async loadCourseLevel() {
    this.cvCourseLevel = await CvValueUtils.getCvValuesByType(CV_VALUE_COURSE_LEVEL)
  }

  private async loadLanguage() {
    this.cvLanguage = await CvValueUtils.getCvValuesByType(CV_VALUE_LANGUAGE)
  }

  private async loadWorkType() {
    this.cvWorkType = await CvValueUtils.getCvValuesByType(CV_VALUE_PRODUCT_WORK_TYPE)
  }

  private async loadCollectionsAndSeries() {
    this.cvCollections = await CvValueUtils.getCvValuesByType(CV_VALUE_PRODUCT_COLLECTION)
    this.cvSeries = await CvValueUtils.getCvValuesByType(CV_VALUE_PRODUCT_SERIES)
  }

  private async loadMaterialTypes() {
    this.materialTypes = await loadMaterialTypes()
  }

  private async loadTeamMembers() {
    const searchOptions: SearchTeamMemberOptions = {
      type: ''
    }
    const response = await ApiClient.getTeamMembers(searchOptions)
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this
    this.teamMembers = response.map((item: TeamMember) => ({ ...item, complete: (vm as any).$options.filters.formatTeamCompleteName(item) }))
  }

  public UpsertProduct(): void {
    if (!this.formOk()) {
      this.$store.dispatch(ActionTypes.SHOW_TOAST, {
        title: this.$t('feedback.error_title_generic'),
        variant: 'danger',
        message: 'Form not valid'
      })
      return
    }

    this.product.metadata = this.formatMetadataToProductMetadata()

    if (this.isUpdate) {
      ApiClient.putProduct(this.product)
        .then((product: Product) => {
          this.$emit('productCreated', product)
          this.hideModal()
          this.clearForm()
          this.$store.dispatch(ActionTypes.SHOW_TOAST, {
            title: this.$t('upsert_product_modal_component.title_update'),
            variant: 'success',
            message: this.$t('upsert_product_modal_component.feedback_message_success_update')
          })
        })
        .catch((e) => {
          this.$store.dispatch(ActionTypes.SHOW_TOAST, {
            title: this.$t('feedback.error_title_generic'),
            variant: 'danger',
            message: this.$t('feedback.error_message_generic') + '. ' + e.response.data.message
          })
        })
    } else {
      ApiClient.createProduct(this.product)
        .then((product: Product) => {
          this.$emit('productCreated', product)
          this.hideModal()
          this.clearForm()
          this.$store.dispatch(ActionTypes.SHOW_TOAST, {
            title: this.$t('upsert_product_modal_component.title'),
            variant: 'success',
            message: this.$t('upsert_product_modal_component.feedback_message_success')
          })
        })
        .catch((e) => {
          this.$store.dispatch(ActionTypes.SHOW_TOAST, {
            title: this.$t('feedback.error_title_generic'),
            variant: 'danger',
            message: this.$t('feedback.error_message_generic') + '. ' + e.response.data.message
          })
        })
    }
  }

  /**
   * Builds the metadata to save from a copy of the form data, so a failed save can be retried
   * without converting the values twice. Every metadata key is kept, shown in the form or not.
   */
  private formatMetadataToProductMetadata() {
    const metadata = { ...this.productMetadata }
    const metadataValues = metadata as unknown as Record<string, unknown>
    PRODUCT_TYPE_FIELDS.forEach(definition => {
      if (!definition.nameField) return
      const cvValue = this.cvOptions(definition).find(item => item.codeId === metadataValues[definition.field])
      if (cvValue) metadataValues[definition.nameField] = cvValue.name
    })

    metadata.educationLevel1 = toShortCode(metadata.educationLevel1, CV_VALUE_EDUCATION)
    metadata.educationLevel2 = toShortCode(metadata.educationLevel2, CV_VALUE_COURSE_LEVEL)
    metadata.subject = toShortCode(metadata.subject, CV_VALUE_SUBJECT)
    metadata.language = toShortCode(metadata.language, CV_VALUE_LANGUAGE)
    metadata.region = this.regionArray.join(',')

    if (metadata.campaign !== '') {
      metadata.campaign = metadata.campaign?.toString()
    }

    if (metadata.productionCampaign !== '') {
      metadata.productionCampaign = metadata.productionCampaign?.toString()
    }

    return metadata
  }

  private formatProductMetadataToMetadata(productMetadata: any) {
    const metadata = Object.assign({}, productMetadata)
    // A stored short code without a matching CV value is kept as it is, so it is not lost on save
    const toCodeId = (value: string | undefined, cvValues: CvValue[]) => {
      const cvValue = value ? cvValues.find(item => item.codeId.split('-')[1] === value) : undefined
      return cvValue ? cvValue.codeId : value
    }

    metadata.educationLevel1 = toCodeId(metadata.educationLevel1, this.cvEducation)
    metadata.educationLevel2 = toCodeId(metadata.educationLevel2, this.cvCourseLevel)
    metadata.subject = toCodeId(metadata.subject, this.cvSubject)
    metadata.language = toCodeId(metadata.language, this.cvLanguage)

    if (metadata.region && metadata.region !== '') {
      const regions = metadata.region.split(',')
      this.regionArray = regions
    }

    return metadata
  }

  /** Fills the code with the next free one of the model series and marks the product as a model */
  public async fillNextModelCode() {
    this.loadingModelCode = true
    try {
      this.product.code = await ApiClient.getNextModelProductCode()
      this.product.isModel = true
    } catch (e) {
      this.$store.dispatch(ActionTypes.SHOW_TOAST, {
        title: this.$t('feedback.error_title_generic'),
        variant: 'danger',
        message: Utils.apiErrorMessage(e)
      })
    } finally {
      this.loadingModelCode = false
    }
  }

  private resetForm() {
    this.clearForm()

    if (this.productUpdate != null && this.productUpdate.id != null) {
      this.product.id = this.productUpdate.id
      this.product.code = this.productUpdate.code
      this.product.name = this.productUpdate.name
      this.product.type = this.productUpdate.type
      this.product.code = this.productUpdate.code
      if (this.productUpdate.editorialProject) {
        this.product.editorialProject = this.productUpdate.editorialProject
      }
      if (this.productUpdate.country) {
        this.product.country = this.productUpdate.country
      }
      if (this.productUpdate.statusType) {
        this.product.statusType = this.productUpdate.statusType
      }
      if (this.productUpdate.workType) {
        this.product.workType = this.productUpdate.workType
      }
      this.product.isModel = !!this.productUpdate.isModel

      const metadata = this.formatProductMetadataToMetadata(this.productUpdate.metadata)
      this.productMetadata = Object.assign(this.productMetadata, metadata)
    }
  }

  private clearForm() {
    this.product.id = ''
    this.product.code = ''
    this.product.name = ''
    this.product.code = ''
    this.product.type = ''
    this.product.editorialProject = ''
    this.product.country = ''
    this.product.statusType = ''
    this.product.workType = ''
    this.product.isModel = false

    this.productMetadata = emptyProductMetadata()
    this.regionArray = []
  }
}
